export function useWeddingExperiment(mpvId: string | undefined | null) {
    return mpvId ? mpvId.toLocaleLowerCase() === 'weddinginvitations' : false;
}
